function loadRecaptcha() {			
	var head = document.head.innerHTML;
	var check = head.search("https://www.google.com/recaptcha/api.js")	
	var spam = document.querySelector('.form_spam');
	if (check === -1) {
		var recapScript = document.createElement("script");
		recapScript.type = "text/javascript";
		recapScript.src = "https://www.google.com/recaptcha/api.js"; 
		document.getElementsByTagName("head")[0].appendChild(recapScript);
		return false;		
	}
	spam.classList.add('shown');
}

var mobileOpen = document.getElementById("mobileOpen");
var mobileClose = document.getElementById("mobileClose");
var page = document.body;
var menuTarget = document.getElementById("mobileMenu");

mobileOpen.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});

mobileClose.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});

/**
 * GA4 — Phone Click
 * Tracks clicks on href="tel"
 */
document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href^="tel:"]');

    if (!link || typeof gtag !== 'function') return;

    gtag('event', 'phone_click', {
        send_to: 'G-1KM61TDWBM',
        phone_number: link.getAttribute('href').slice(4),
        link_text: link.textContent.trim(),
        page_location: window.location.href
    });
});


/**
 * GA4 — ServiceTitan scheduler launch
 * Tracks clicks on buttons using _scheduler.show()
 */
document.addEventListener('click', function (event) {
    const button = event.target.closest(
        '[onclick*="_scheduler.show"]'
    );

    if (!button || typeof gtag !== 'function') return;

    gtag('event', 'schedule_click', {
        send_to: 'G-1KM61TDWBM',
        link_text: button.textContent.trim(),
        page_location: window.location.href
    });
});



/**
 * GA4 — Coupon print clicks
 */
document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-ga4="coupon_print"]');

    if (!link || typeof gtag !== 'function') return;

    gtag('event', 'coupon_print', {
        send_to: 'G-1KM61TDWBM',
        coupon_name: link.dataset.coupon,
        page_location: window.location.href
    });
});
